import type { FC } from 'react';
import { ProductThumbnail, Tag, Text } from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

export interface ProductSamplingItemProps {
  'data-testid'?: string;
  className?: string;
  title: string;
  imageUrl: string;
}

const ProductSamplingItem: FC<ProductSamplingItemProps> = ({
  'data-testid': dataTestId = 'paris-productsamplingitem',
  title,
  imageUrl,
  className
}) => (
  <div
    data-testid={dataTestId}
    className={classNames('co-flex co-gap-3', className)}
  >
    <ProductThumbnail src={imageUrl} />
    <div className="co-flex co-flex-col co-min-w-0 co-h-[45px]">
      <div className="co-overflow-hidden co-text-ellipsis co-whitespace-nowrap">
        <Text variant="body2" weight={600}>
          {title}
        </Text>
      </div>
      <div>
        <Tag>Gratis</Tag>
      </div>
    </div>
  </div>
);

export default ProductSamplingItem;
